<section class="tabs">
    <ul>
        <li [ngClass]="{'active': tipoEstadisticas === 1}" (click)="showCultivosPais()">
            {{'centralEstadisticas.cultivos.tabs.nCultivosPais.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 2}" (click)="showCultivosDenominacion()">
            {{'centralEstadisticas.cultivos.tabs.nCultivosDenominacion.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 3}" (click)="showCultivosCampanya()">
            {{'centralEstadisticas.cultivos.tabs.nCultivosCampanyas.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 4}" (click)="showAforosPais()">
            {{'centralEstadisticas.cultivos.tabs.aforosPais.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 5}" (click)="showAforosDenominacion()">
            {{'centralEstadisticas.cultivos.tabs.aforosDenominacion.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 6}" (click)="showAforosCampanyas()">
            {{'centralEstadisticas.cultivos.tabs.aforosCampanyas.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 7}" (click)="showSuperficiePais()">
            {{'centralEstadisticas.cultivos.tabs.superficiePais.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 8}" (click)="showSuperficieDenominacion()">
            {{'centralEstadisticas.cultivos.tabs.superficieDenominacion.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 9}" (click)="showSuperficieCampanyas()">
            {{'centralEstadisticas.cultivos.tabs.superficieCampanyas.titulo' | translate}}
        </li>
    </ul>
    <content>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 1">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.cultivos.tabs.nCultivosPais.paises' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica1">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasCultivos.grafica1.horizontal" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [categorias]="graficasCultivos.grafica1.paises"
                                    [data]="graficasCultivos.grafica1.numCultivos"
                                    [valorMaximo]="graficasCultivos.grafica1.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosPais.descripcionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                      class="grid" 
                                      [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                      (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosPais.paises', dataCultivos.cultivos_CultivosPais_Paises_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica1">
                                <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica1.paises"
                                    [series]="graficasCultivos.grafica1.numCultivos" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [colors]="graficasCultivos.grafica1.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
				<div class= "section" style="justify-content: center;">
					<div>
                        <h3>{{'centralEstadisticas.cultivos.tabs.nCultivosPais.paisDenominaciones' | translate}}</h3>
					</div>
				</div> 
                <div class="section">
                    <div *ngIf="graficasCultivos && graficasCultivos.grafica2.cultivos"
                         [ngClass]="{'controlDisplay': !graficasCultivos.grafica2.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica2.bigWidthEtq" [stackType]="'normal'"
                                    [info]="graficasCultivos.grafica2.cultivos"
                                    [categorias]="graficasCultivos.grafica2.categorias"
                                    [valorMaximo]="graficasCultivos.grafica2.valorMaximo"
                                    [showDatalabels]="true" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [colors]="graficasCultivos.grafica2.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosPais.descripcionPaisDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                      class="grid" 
                                      [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                      (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosPais.paisDenominaciones', dataCultivos.cultivos_CultivosPais_PaisDenominaciones_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica2.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica2.bigWidthPes" [stackType]="'100%'"
                                    [info]="graficasCultivos.grafica2.porcentajes"
                                    [categorias]="graficasCultivos.grafica2.categorias"
                                    [showDatalabels]="true" [nombre]="'%'"
                                    [colors]="graficasCultivos.grafica2.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 2">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.cultivos.tabs.nCultivosDenominacion.denominaciones' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica3">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasCultivos.grafica3.horizontal" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [categorias]="graficasCultivos.grafica3.denominaciones"
                                    [data]="graficasCultivos.grafica3.numCultivos" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [valorMaximo]="graficasCultivos.grafica3.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosDenominacion.descripcionDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                      class="grid" 
                                      [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                      (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosDenominacion.denominaciones', dataCultivos.cultivos_CultivosDenominacion_Denominaciones_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica3">
                                <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica3.denominaciones"
                                    [series]="graficasCultivos.grafica3.numCultivos" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [colors]="graficasCultivos.grafica3.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
				<div class= "section" style="justify-content: center;">
					<div>
						<h3>{{'centralEstadisticas.cultivos.tabs.nCultivosDenominacion.denominacionPaises' | translate}}</h3>
					</div>
				</div> 
                <div class="section">
                    <div *ngIf="graficasCultivos && graficasCultivos.grafica4.cultivos"
                         [ngClass]="{'controlDisplay': !graficasCultivos.grafica4.bigWidthEtq}">
                        <div class="container">
                            <div class="grafica">
                                <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica4.bigWidthEtq" [stackType]="'normal'"
                                    [info]="graficasCultivos.grafica4.cultivos"
                                    [categorias]="graficasCultivos.grafica4.categorias"
                                    [valorMaximo]="graficasCultivos.grafica4.valorMaximo"
                                    [showDatalabels]="true" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [colors]="graficasCultivos.grafica4.colores"></lib-stacked-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosDenominacion.descripcionDenominacionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                      class="grid" 
                                      [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                      (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosDenominacion.denominacionPaises', dataCultivos.cultivos_CultivosDenominacion_DenominacionPaises_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica4.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica4.bigWidthPes" [stackType]="'100%'"
                                    [info]="graficasCultivos.grafica4.porcentajes"
                                    [categorias]="graficasCultivos.grafica4.categorias"
                                    [showDatalabels]="true" [nombre]="'%'"
                                    [colors]="graficasCultivos.grafica4.colores"></lib-stacked-bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 3">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.cultivos.tabs.nCultivosCampanyas.campanyas' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica5">
                        <div class="container">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="graficasCultivos.grafica5.horizontal" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [categorias]="graficasCultivos.grafica5.anyos"
                                    [data]="graficasCultivos.grafica5.numCultivos"
                                    [valorMaximo]="graficasCultivos.grafica5.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosCampanyas.descripcionCampanyas' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <button 
                                      class="grid" 
                                      [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                      (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosCampanyas.campanyas', dataCultivos.cultivos_CultivosCampanyas_Campanyas_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                            <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica5">
                                <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica5.anyos"
                                    [series]="graficasCultivos.grafica5.numCultivos" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                    [colors]="graficasCultivos.grafica5.colores"></lib-simple-dougnhut-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                    <h3>{{'centralEstadisticas.cultivos.tabs.nCultivosCampanyas.paisesCampanya' | translate}}</h3>
                </div>
              </div>  
              <div class="section">
                  <div *ngIf="graficasCultivos && graficasCultivos.grafica6.cultivos"
                      [ngClass]="{'controlDisplay': !graficasCultivos.grafica6.bigWidthEtq}">
                      <div class="container">
                          <div class="grafica">
                              <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica6.bigWidthEtq" [stackType]="'normal'"
                                  [info]="graficasCultivos.grafica6.cultivos"
                                  [categorias]="graficasCultivos.grafica6.categorias"
                                  [valorMaximo]="graficasCultivos.grafica6.valorMaximo"
                                  [showDatalabels]="true" [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                  [colors]="graficasCultivos.grafica6.colores"></lib-stacked-bar-chart>
                              <div class="buttons-section">
                                  <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosCampanyas.descripcionPaisesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                                  <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosCampanyas.paisesCampanya', dataCultivos.cultivos_CultivosCampanyas_PaisesCampanya_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                                  <!-- <button><i class="fas fa-file-pdf"></i></button>
                                  <button><i class="fas fa-file-excel"></i></button> -->
                              </div>
                          </div>
                      </div>
                      <div class="container">
                          <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica6.porcentajes">
                                  <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica6.bigWidthPes" [stackType]="'100%'"
                                      [info]="graficasCultivos.grafica6.porcentajes"
                                      [categorias]="graficasCultivos.grafica6.categorias"
                                      [showDatalabels]="true" [nombre]="'%'"
                                      [colors]="graficasCultivos.grafica6.colores"></lib-stacked-bar-chart>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.nCultivosCampanyas.denominacionesCampanya' | translate}}</h3>
                </div>
              </div>  
              <div class="section">
                  <div *ngIf="graficasCultivos && graficasCultivos.grafica7.cultivos"
                  [ngClass]="{'controlDisplay': !graficasCultivos.grafica7.bigWidthEtq}">
                      <div class="container">
                          <div class="grafica">
                              <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica7.bigWidthEtq" [stackType]="'normal'"
                                  [info]="graficasCultivos.grafica7.cultivos"
                                  [categorias]="graficasCultivos.grafica7.categorias"
                                  [valorMaximo]="graficasCultivos.grafica7.valorMaximo"
                                  [showDatalabels]="true"
                                  [nombre]="('centralEstadisticas.cultivos.nCultivos' | translate)"
                                  [colors]="graficasCultivos.grafica7.colores"></lib-stacked-bar-chart>
                              <div class="buttons-section">
                                  <button [tooltip]="('centralEstadisticas.cultivos.tabs.nCultivosCampanyas.descripcionDenominacionesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                                  <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.cultivos.tabs.nCultivosCampanyas.denominacionesCampanya', dataCultivos.cultivos_CultivosCampanyas_DenominacionesCampanya_Grid_3, 'bars')"><i class="fas fa-table"></i></button>
                                  <!-- <button><i class="fas fa-file-pdf"></i></button>
                                  <button><i class="fas fa-file-excel"></i></button> -->
                              </div>
                          </div>
                      </div>
                      <div class="container">
                          <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica7.porcentajes">
                                  <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica7.bigWidthPes" [stackType]="'100%'"
                                      [info]="graficasCultivos.grafica7.porcentajes"
                                      [categorias]="graficasCultivos.grafica7.categorias"
                                      [showDatalabels]="true" [nombre]="'%'"
                                      [colors]="graficasCultivos.grafica7.colores"></lib-stacked-bar-chart>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 4">
            <div class="section">
              <div style="flex-direction: column;">
                <div class= "section">
                    <div>
                        <h3>{{'centralEstadisticas.cultivos.tabs.aforosPais.paises' | translate}}</h3>
                    </div>
                </div>
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica8">
                  <div class="container">
                      <div class="grafica">
                          <lib-bar-chart [horizontal]="graficasCultivos.grafica8.horizontal" [nombre]="'Kg'"
                                [categorias]="graficasCultivos.grafica8.paises"
                                [data]="graficasCultivos.grafica8.sumAforos"
                                [valorMaximo]="graficasCultivos.grafica8.valorMaximo"></lib-bar-chart>
                          <div class="buttons-section">
                              <button [tooltip]="('centralEstadisticas.cultivos.tabs.aforosPais.descripcionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                              <button 
                                class="grid" 
                                [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosPais.paises', dataCultivos.cultivos_AforosPais_Paises_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                              <!-- <button><i class="fas fa-file-pdf"></i></button>
                              <button><i class="fas fa-file-excel"></i></button> -->
                          </div>
                      </div>
                      <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica8">
                        <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica8.paises"
                            [series]="graficasCultivos.grafica8.sumAforos" [nombre]="'Kg'"
                            [colors]="graficasCultivos.grafica8.colores"></lib-simple-dougnhut-chart>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.aforosPais.paisDenominaciones' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div *ngIf="graficasCultivos && graficasCultivos.grafica9.cultivos"
                    [ngClass]="{'controlDisplay': !graficasCultivos.grafica9.bigWidthEtq}">
                  <div class="container">
                    <div class="grafica">
                        <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica9.bigWidthEtq" [stackType]="'normal'"
                            [info]="graficasCultivos.grafica9.cultivos"
                            [categorias]="graficasCultivos.grafica9.categorias"
                            [valorMaximo]="graficasCultivos.grafica9.valorMaximo"
                            [showDatalabels]="true" [nombre]="'Kg'"
                            [colors]="graficasCultivos.grafica9.colores"></lib-stacked-bar-chart>
                        <div class="buttons-section">
                            <button [tooltip]="('centralEstadisticas.cultivos.tabs.aforosPais.descripcionPaisDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                            <button 
                              class="grid" 
                              [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                              (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosPais.paisDenominaciones', dataCultivos.cultivos_AforosPais_PaisDenominaciones_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                            <!-- <button><i class="fas fa-file-pdf"></i></button>
                            <button><i class="fas fa-file-excel"></i></button> -->
                        </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica9.porcentajes">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica9.bigWidthPes" [stackType]="'100%'"
                          [info]="graficasCultivos.grafica9.porcentajes"
                          [categorias]="graficasCultivos.grafica9.categorias"
                          [showDatalabels]="true" [nombre]="'%'"
                          [colors]="graficasCultivos.grafica9.colores"></lib-stacked-bar-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 5">
            <div class="section">
              <div style="flex-direction: column;">
                <div class= "section">
                    <div>
                      <h3>{{'centralEstadisticas.cultivos.tabs.aforosDenominacion.denominaciones' | translate}}</h3>
                    </div>
                </div>
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica10">
                  <div class="container">
                    <div class="grafica">
                        <lib-bar-chart [horizontal]="graficasCultivos.grafica10.horizontal" [nombre]="'Kg'"
                            [categorias]="graficasCultivos.grafica10.denominaciones"
                            [data]="graficasCultivos.grafica10.sumAforos"
                            [valorMaximo]="graficasCultivos.grafica10.valorMaximo"></lib-bar-chart>
                        <div class="buttons-section">
                            <button [tooltip]="('centralEstadisticas.cultivos.tabs.aforosDenominacion.descripcionDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                            <button 
                              class="grid" 
                              [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                              (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosDenominacion.denominaciones', dataCultivos.cultivos_AforosDenominacion_Denominaciones_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                            <!-- <button><i class="fas fa-file-pdf"></i></button>
                            <button><i class="fas fa-file-excel"></i></button> -->
                        </div>
                    </div>
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica10">
                        <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica10.denominaciones"
                            [series]="graficasCultivos.grafica10.sumAforos" [nombre]="'Kg'"
                            [colors]="graficasCultivos.grafica10.colores"></lib-simple-dougnhut-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.aforosDenominacion.denominacionPaises' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div *ngIf="graficasCultivos && graficasCultivos.grafica11.cultivos"
                    [ngClass]="{'controlDisplay': !graficasCultivos.grafica11.bigWidthEtq}">
                  <div class="container">
                    <div class="grafica">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica11.bigWidthEtq" [stackType]="'normal'"
                          [info]="graficasCultivos.grafica11.cultivos"
                          [categorias]="graficasCultivos.grafica11.categorias"
                          [valorMaximo]="graficasCultivos.grafica11.valorMaximo"
                          [showDatalabels]="true" [nombre]="'Kg'"
                          [colors]="graficasCultivos.grafica11.colores"></lib-stacked-bar-chart>
                      <div class="buttons-section">
                          <button [tooltip]="('centralEstadisticas.cultivos.tabs.aforosDenominacion.descripcionDenominacionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                          <button 
                            class="grid" 
                            [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                            (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosDenominacion.denominacionPaises', dataCultivos.cultivos_AforosDenominacion_DenominacionPaises_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                          <!-- <button><i class="fas fa-file-pdf"></i></button>
                          <button><i class="fas fa-file-excel"></i></button> -->
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica11.porcentajes">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica11.bigWidthPes" [stackType]="'100%'"
                          [info]="graficasCultivos.grafica11.porcentajes"
                          [categorias]="graficasCultivos.grafica11.categorias"
                          [showDatalabels]="true" [nombre]="'%'"
                          [colors]="graficasCultivos.grafica11.colores"></lib-stacked-bar-chart>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 6">
            <div class="section">
              <div style="flex-direction: column;">
                <div class= "section">
                    <div>
                      <h3>{{'centralEstadisticas.cultivos.tabs.aforosCampanyas.campanyas' | translate}}</h3>
                    </div>
                </div>
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica12">
                  <div class="container">
                    <div class="grafica">
                      <lib-bar-chart [horizontal]="graficasCultivos.grafica12.horizontal" [nombre]="'Kg: '"
                          [categorias]="graficasCultivos.grafica12.anyos"
                          [data]="graficasCultivos.grafica12.sumAforos"
                          [valorMaximo]="graficasCultivos.grafica12.valorMaximo"></lib-bar-chart>
                      <div class="buttons-section">
                          <button [tooltip]="('centralEstadisticas.cultivos.tabs.aforosCampanyas.descripcionCampanyas' | translate)"><i class="fa-solid fa-info"></i></button>
                          <button 
                            class="grid" 
                            [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                            (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosCampanyas.campanyas', dataCultivos.cultivos_AforosCampanyas_Campanyas_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                          <!-- <button><i class="fas fa-file-pdf"></i></button>
                          <button><i class="fas fa-file-excel"></i></button> -->
                      </div>
                    </div>
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica12">
                        <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica12.anyos"
                            [series]="graficasCultivos.grafica12.sumAforos" [nombre]="'Kg'"
                            [colors]="graficasCultivos.grafica12.colores"></lib-simple-dougnhut-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.aforosCampanyas.paisesCampanya' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div *ngIf="graficasCultivos && graficasCultivos.grafica13.cultivos"
                    [ngClass]="{'controlDisplay': !graficasCultivos.grafica13.bigWidthEtq}">
                  <div class="container">
                    <div class="grafica">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica13.bigWidthEtq" [stackType]="'normal'"
                                [info]="graficasCultivos.grafica13.cultivos"
                                [categorias]="graficasCultivos.grafica13.categorias"
                                [valorMaximo]="graficasCultivos.grafica13.valorMaximo"
                                [showDatalabels]="true" [nombre]="'Kg'"
                                [colors]="graficasCultivos.grafica13.colores"></lib-stacked-bar-chart>
                      <div class="buttons-section">
                        <button [tooltip]="('centralEstadisticas.cultivos.tabs.aforosCampanyas.descripcionPaisesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                        <button 
                          class="grid" 
                          [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                          (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosCampanyas.paisesCampanya', dataCultivos.cultivos_AforosCampanyas_PaisesCampanya_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                        <!-- <button><i class="fas fa-file-pdf"></i></button>
                        <button><i class="fas fa-file-excel"></i></button> -->
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica13.porcentajes">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica13.bigWidthPes" [stackType]="'100%'"
                                [info]="graficasCultivos.grafica13.porcentajes"
                                [categorias]="graficasCultivos.grafica13.categorias"
                                [showDatalabels]="true" [nombre]="'%'"
                                [colors]="graficasCultivos.grafica13.colores"></lib-stacked-bar-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.aforosCampanyas.denominacionesCampanya' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div *ngIf="graficasCultivos && graficasCultivos.grafica14.cultivos"
                [ngClass]="{'controlDisplay': !graficasCultivos.grafica14.bigWidthEtq}">
                  <div class="container">
                    <div class="grafica">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica14.bigWidthEtq" [stackType]="'normal'"
                                [info]="graficasCultivos.grafica14.cultivos"
                                [categorias]="graficasCultivos.grafica14.categorias"
                                [valorMaximo]="graficasCultivos.grafica14.valorMaximo"
                                [showDatalabels]="true" [nombre]="'Kg'"
                                [colors]="graficasCultivos.grafica14.colores"></lib-stacked-bar-chart>
                      <div class="buttons-section">
                        <button  [tooltip]="('centralEstadisticas.cultivos.tabs.aforosCampanyas.descripcionDenominacionesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                        <button 
                          class="grid" 
                          [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                          (click)="showGrid('centralEstadisticas.cultivos.tabs.aforosCampanyas.denominacionesCampanya', dataCultivos.cultivos_AforosCampanyas_DenominacionesCampanya_Grid_3, 'bars')"><i class="fas fa-table"></i></button>
                        <!-- <button><i class="fas fa-file-pdf"></i></button>
                        <button><i class="fas fa-file-excel"></i></button> -->
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica14.porcentajes">
                      <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica14.bigWidthPes" [stackType]="'100%'"
                                [info]="graficasCultivos.grafica14.porcentajes"
                                [categorias]="graficasCultivos.grafica14.categorias"
                                [showDatalabels]="true" [nombre]="'%'"
                                [colors]="graficasCultivos.grafica14.colores"></lib-stacked-bar-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 7">
            <div class="section">
              <div style="flex-direction: column;">
                <div class= "section">
                    <div>
                      <h3>{{'centralEstadisticas.cultivos.tabs.superficiePais.paises' | translate}}</h3>
                    </div>
                </div>
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica15">
                    <div class="container">
                        <div class="grafica">
                            <lib-bar-chart [horizontal]="graficasCultivos.grafica15.horizontal" [nombre]="'Ha'"
                                [categorias]="graficasCultivos.grafica15.paises"
                                [data]="graficasCultivos.grafica15.sumSuperificies"
                                [valorMaximo]="graficasCultivos.grafica15.valorMaximo"></lib-bar-chart>
                            <div class="buttons-section">
                                <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficiePais.descripcionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                <button 
                                  class="grid" 
                                  [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                  (click)="showGrid('centralEstadisticas.cultivos.tabs.superficiePais.paises', dataCultivos.cultivos_SuperficiePais_Paises_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                                <!-- <button><i class="fas fa-file-pdf"></i></button>
                                <button><i class="fas fa-file-excel"></i></button> -->
                            </div>
                        </div>
                        <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica15">
                            <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica15.paises"
                                [series]="graficasCultivos.grafica15.sumSuperificies" [nombre]="'Ha'"
                                [colors]="graficasCultivos.grafica15.colores"></lib-simple-dougnhut-chart>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.superficiePais.paisDenominaciones' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                  <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica16.cultivos"
                    [ngClass]="{'controlDisplay': !graficasCultivos.grafica16.bigWidthEtq}">
                      <div class="container">
                          <div class="grafica">
                              <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica16.bigWidthEtq" [stackType]="'normal'"
                                  [info]="graficasCultivos.grafica16.cultivos"
                                  [categorias]="graficasCultivos.grafica16.categorias"
                                  [valorMaximo]="graficasCultivos.grafica16.valorMaximo"
                                  [showDatalabels]="true" [nombre]="'Ha'"
                                  [colors]="graficasCultivos.grafica16.colores"></lib-stacked-bar-chart>
                              <div class="buttons-section">
                                  <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficiePais.descripcionPaisDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                  <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.cultivos.tabs.superficiePais.paisDenominaciones', dataCultivos.cultivos_SuperficiePais_PaisDenominaciones_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                                  <!-- <button><i class="fas fa-file-pdf"></i></button>
                                  <button><i class="fas fa-file-excel"></i></button> -->
                              </div>
                          </div>
                      </div>
                      <div class="container">
                          <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica16.porcentajes">
                                <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica16.bigWidthPes" [stackType]="'100%'"
                                    [info]="graficasCultivos.grafica16.porcentajes"
                                    [categorias]="graficasCultivos.grafica16.categorias"
                                    [showDatalabels]="true" [nombre]="'%'"
                                    [colors]="graficasCultivos.grafica16.colores"></lib-stacked-bar-chart>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 8">
            <div class="section">
              <div style="flex-direction: column;">
                  <div class= "section">
                    <div>
                      <h3>{{'centralEstadisticas.cultivos.tabs.superficieDenominacion.denominaciones' | translate}}</h3>
                    </div>
                  </div>
                  <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica17">
                    <div class="container">
                          <div class="grafica">
                              <lib-bar-chart [horizontal]="graficasCultivos.grafica17.horizontal" [nombre]="'Ha'"
                                  [categorias]="graficasCultivos.grafica17.denominaciones"
                                  [nombre]="'Ha'"
                                  [data]="graficasCultivos.grafica17.sumSuperificies"
                                  [valorMaximo]="graficasCultivos.grafica17.valorMaximo"></lib-bar-chart>
                              <div class="buttons-section">
                                  <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficieDenominacion.descripcionDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                  <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.cultivos.tabs.superficieDenominacion.denominaciones', dataCultivos.cultivos_SuperficieDenominacion_Denominaciones_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                                  <!-- <button><i class="fas fa-file-pdf"></i></button>
                                  <button><i class="fas fa-file-excel"></i></button> -->
                              </div>
                          </div>
                          <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica17">
                              <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica17.denominaciones"
                                  [series]="graficasCultivos.grafica17.sumSuperificies" [nombre]="'Ha'"
                                  [colors]="graficasCultivos.grafica17.colores"></lib-simple-dougnhut-chart>
                          </div>
                    </div>
                  </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.superficieDenominacion.denominacionPaises' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica18.cultivos"
                  [ngClass]="{'controlDisplay': !graficasCultivos.grafica18.bigWidthEtq}">
                    <div class="container">
                          <div class="grafica">
                              <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica18.bigWidthEtq" [stackType]="'normal'"
                                  [info]="graficasCultivos.grafica18.cultivos"
                                  [categorias]="graficasCultivos.grafica18.categorias"
                                  [valorMaximo]="graficasCultivos.grafica18.valorMaximo"
                                  [showDatalabels]="true" [nombre]="'Ha'"
                                  [colors]="graficasCultivos.grafica18.colores"></lib-stacked-bar-chart>
                              <div class="buttons-section">
                                  <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficieDenominacion.descripcionDenominacionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                  <button 
                                    class="grid" 
                                    [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                    (click)="showGrid('centralEstadisticas.cultivos.tabs.superficieDenominacion.denominacionPaises', dataCultivos.cultivos_SuperficieDenominacion_DenominacionPaises_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                                  <!-- <button><i class="fas fa-file-pdf"></i></button>
                                  <button><i class="fas fa-file-excel"></i></button> -->
                              </div>
                          </div>
                    </div>
                    <div class="container">
                      <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica18.porcentajes">
                              <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica18.bigWidthPes" [stackType]="'100%'"
                                  [info]="graficasCultivos.grafica18.porcentajes"
                                  [categorias]="graficasCultivos.grafica18.categorias"
                                  [showDatalabels]="true" [nombre]="'%'"
                                  [colors]="graficasCultivos.grafica18.colores"></lib-stacked-bar-chart>
                      </div>
                    </div>
                </div>
              </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 9">
            <div class="section">
              <div style="flex-direction: column;">
                <div class= "section">
                    <div>
                      <h3>{{'centralEstadisticas.cultivos.tabs.superficieCampanyas.campanyas' | translate}}</h3>
                    </div>
                </div>
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica19">
                  <div class="container">
                    <div class="grafica">
                        <lib-bar-chart [horizontal]="graficasCultivos.grafica19.horizontal" [nombre]="'Ha'"
                            [categorias]="graficasCultivos.grafica19.anyos"
                            [data]="graficasCultivos.grafica19.sumSuperificies"
                            [valorMaximo]="graficasCultivos.grafica19.valorMaximo"></lib-bar-chart>
                        <div class="buttons-section">
                            <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficieCampanyas.descripcionCampanyas' | translate)"><i class="fa-solid fa-info"></i></button>
                            <button 
                              class="grid" 
                              [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                              (click)="showGrid('centralEstadisticas.cultivos.tabs.superficieCampanyas.campanyas', dataCultivos.cultivos_SuperficieCampanyas_Campanyas_1.lista, 'donut')"><i class="fas fa-table"></i></button>
                            <!-- <button><i class="fas fa-file-pdf"></i></button>
                            <button><i class="fas fa-file-excel"></i></button> -->
                        </div>
                    </div>
                    <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica19">
                        <lib-simple-dougnhut-chart [labels]="graficasCultivos.grafica19.anyos"
                            [series]="graficasCultivos.grafica19.sumSuperificies" [nombre]="'Ha'"
                            [colors]="graficasCultivos.grafica19.colores"></lib-simple-dougnhut-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.superficieCampanyas.paisesCampanya' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica20.cultivos">
                  <div class="container">
                        <div class="grafica">
                            <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica20.bigWidthEtq" [stackType]="'normal'"
                                [info]="graficasCultivos.grafica20.cultivos"
                                [categorias]="graficasCultivos.grafica20.categorias"
                                [valorMaximo]="graficasCultivos.grafica20.valorMaximo"
                                [showDatalabels]="true" [nombre]="'Ha'"
                                [colors]="graficasCultivos.grafica20.colores"></lib-stacked-bar-chart>
                            <div class="buttons-section">
                                <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficieCampanyas.descripcionPaisesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                                <button 
                                  class="grid" 
                                  [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                  (click)="showGrid('centralEstadisticas.cultivos.tabs.superficieCampanyas.paisesCampanya', dataCultivos.cultivos_SuperficieCampanyas_PaisesCampanya_Grid_2, 'bars')"><i class="fas fa-table"></i></button>
                                <!-- <button><i class="fas fa-file-pdf"></i></button>
                                <button><i class="fas fa-file-excel"></i></button> -->
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica20.porcentajes">
                          <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica20.bigWidthPes" [stackType]="'100%'"
                          [info]="graficasCultivos.grafica20.porcentajes"
                          [categorias]="graficasCultivos.grafica20.categorias"
                          [showDatalabels]="true" [nombre]="'%'"
                          [colors]="graficasCultivos.grafica20.colores"></lib-stacked-bar-chart>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div style="flex-direction: column;">
              <div class= "section" style="justify-content: center;">
                <div>
                  <h3>{{'centralEstadisticas.cultivos.tabs.superficieCampanyas.denominacionesCampanya' | translate}}</h3>
                </div>
              </div>
              <div class="section">
                <div class="" *ngIf="graficasCultivos && graficasCultivos.grafica21.cultivos"
                  [ngClass]="{'controlDisplay': !graficasCultivos.grafica21.bigWidthEtq}">
                    <div class="container">
                        <div class="grafica">
                            <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica21.bigWidthEtq" [stackType]="'normal'"
                                [info]="graficasCultivos.grafica21.cultivos"
                                [categorias]="graficasCultivos.grafica21.categorias"
                                [valorMaximo]="graficasCultivos.grafica21.valorMaximo"
                                [showDatalabels]="true" [nombre]="'Ha'"
                                [colors]="graficasCultivos.grafica21.colores"></lib-stacked-bar-chart>
                            <div class="buttons-section">
                                <button [tooltip]="('centralEstadisticas.cultivos.tabs.superficieCampanyas.descripcionDenominacionesCampanya' | translate)"><i class="fa-solid fa-info"></i></button>
                                <button 
                                  class="grid" 
                                  [tooltip]="('centralEstadisticas.mostrarTabla' | translate)" 
                                  (click)="showGrid('centralEstadisticas.cultivos.tabs.superficieCampanyas.denominacionesCampanya', dataCultivos.cultivos_SuperficieCampanyas_DenominacionesCampanya_Grid_3, 'bars')"><i class="fas fa-table"></i></button>
                                <!-- <button><i class="fas fa-file-pdf"></i></button>
                                <button><i class="fas fa-file-excel"></i></button> -->
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="grafica" *ngIf="graficasCultivos && graficasCultivos.grafica21.porcentajes">
                          <lib-stacked-bar-chart [horizontal]="graficasCultivos.grafica21.bigWidthPes" [stackType]="'100%'"
                          [info]="graficasCultivos.grafica21.porcentajes"
                          [categorias]="graficasCultivos.grafica21.categorias"
                          [showDatalabels]="true" [nombre]="'%'"
                          [colors]="graficasCultivos.grafica21.colores"></lib-stacked-bar-chart>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        </section>
    </content>
</section>
<div class="modal" *ngIf="gridModal">
  <div class="modal-content">
      <header>
          <h4>{{gridTitle | translate}}</h4>
          <i class="fas fa-times" (click)="gridModal = !gridModal"></i>
        </header>
      <app-grid-estadisticas-cultivo class="component" [dataGrid]="parentDataGrid" (hideTable)="hideModal()"></app-grid-estadisticas-cultivo>
  </div>
</div>